import axios from './axiosConfig';

// El menú valida el permiso 61 mediante checkPerm antes de invocar esta función.
export async function descargarReporteGeneral(token) {



    const respuesta = await axios.request({
        url: `${process.env.REACT_APP_SERVER}/resumentotal`,
        method: 'GET',
        ...(token ? { headers: { Authorization: `Bearer ${token}` } } : {}),
        responseType: 'blob',
    });



    const archivo = respuesta.data;
    console.log('Archivo descargado:', archivo);
    const tipo = respuesta.headers?.['content-type'] || archivo?.type || '';
    if (!(archivo instanceof Blob) || archivo.size === 0 || /json|text\/|html/i.test(tipo)) {
        throw new Error('El servidor no devolvió un archivo Excel válido.');
    }

    const nombre = /application\/vnd\.ms-excel(?:;|$)/i.test(tipo)
        ? 'Reporte_general.xls'
        : 'Reporte_general.xlsx';
    const objectUrl = URL.createObjectURL(archivo);
    const enlace = document.createElement('a');
    enlace.href = objectUrl;
    enlace.download = nombre;
    document.body.appendChild(enlace);
    try {
        enlace.click();
    } finally {
        enlace.remove();
        // Dar tiempo al navegador para iniciar la descarga antes de liberar el Blob.
        setTimeout(() => URL.revokeObjectURL(objectUrl), 1000);
    }

    return nombre;
}
